/* Elya: aynı modelin diğer renkleri (ayrı ürün sayfaları) – 30 Eki 2026 */
(function () {
  var KEY = 'eb-renk-v1', TTL = 30 * 60 * 1000, load;
  function base(t) { t = t.replace(/\s*\([^)]*\)/g, '').trim(); var i = t.lastIndexOf(' - '); return (i > 0 ? t.slice(0, i) : t).trim().toLowerCase(); }
  function color(p) {
    var o = (p.options || []).find(function (x) { return /renk|color/i.test(x.name); });
    var t = p.title.replace(/\s*\([^)]*\)/g, ''), i = t.lastIndexOf(' - ');
    var c = o && o.values && o.values.length === 1 ? o.values[0] : (i > 0 ? t.slice(i + 3) : '');
    var m = p.title.match(/\((M\d+)\)/); return c + (m ? ' ' + m[1] : '');
  }
  function thumb(p) { var s = p.images && p.images[0] && p.images[0].src; return s ? s.replace(/(\.\w+)(\?|$)/, '_160x$1$2') : ''; }
  function data() {
    if (load) return load;
    try { var c = JSON.parse(sessionStorage.getItem(KEY)); if (c && Date.now() - c.t < TTL) return (load = Promise.resolve(c.g)); } catch (e) {}
    load = fetch('/products.json?limit=250').then(function (r) { return r.json(); }).then(function (j) {
      var g = {};
      j.products.forEach(function (p) { var b = base(p.title); (g[b] = g[b] || []).push({ h: p.handle, c: color(p), i: thumb(p), a: p.variants.some(function (v) { return v.available; }) }); });
      Object.keys(g).forEach(function (k) { if (g[k].length < 2) delete g[k]; });
      try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), g: g })); } catch (e) {}
      return g;
    });
    return load;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function render(el, g) {
    var list = g[base(el.dataset.title)]; if (!list) return;
    var cur = el.dataset.handle, card = el.dataset.mode === 'card', me = list.find(function (x) { return x.h === cur; });
    var items = list.map(function (x) {
      var on = x.h === cur;
      return '<a href="/products/' + x.h + '" class="eb-renk' + (on ? ' is-on' : '') + (x.a ? '' : ' is-out') + '" title="' + esc(x.c) + '"' + (on ? ' aria-current="true"' : '') + '>' +
        (x.i ? '<img src="' + x.i + '" alt="' + esc(x.c) + '" loading="lazy" width="80" height="80">' : '') + (card ? '' : '<span>' + esc(x.c) + '</span>') + '</a>';
    }).join('');
    el.innerHTML = card ? '<div class="eb-renkler__list">' + items + '</div>'
      : '<div class="eb-renkler__head">Renk: <strong>' + esc(me ? me.c : '') + '</strong> <small>' + list.length + ' renk seçeneği</small></div><div class="eb-renkler__list">' + items + '</div>';
    el.hidden = false;
    if (!card) document.querySelectorAll('variant-selects fieldset').forEach(function (f) { var l = f.querySelector('legend'); if (l && /renk|color/i.test(l.textContent)) f.style.display = 'none'; });
  }
  function run(root) { var els = (root || document).querySelectorAll('eb-renkler[hidden]:not([data-done])'); if (!els.length) return; els.forEach(function (e) { e.dataset.done = 1; }); data().then(function (g) { els.forEach(function (e) { render(e, g); }); }).catch(function () {}); }
  run();
  new MutationObserver(function () { run(); }).observe(document.body, { childList: true, subtree: true });
})();
